import { doc, runTransaction, serverTimestamp, Timestamp, updateDoc } from "firebase/firestore"
import { firestore } from "../firebase"

// Makes sure users/{uid} has the new-user fields (createdAt, balance 0, plan "free").
// Sign-in and the landing-trial link (tryon.js) run in parallel; before this, the
// link could create the doc first and sign-in then saw an existing doc and only set
// email/lastLogin, so balance/plan/createdAt were missing for most trial sign-ups.
// Returns true if the doc was created here.
export async function ensureUserDoc(user, { touchLogin = true } = {}) {
  if (!user?.uid) return false
  const ref = doc(firestore, "users", user.uid)

  let created = false
  let existing = null
  await runTransaction(firestore, async (tx) => {
    const snap = await tx.get(ref)
    if (snap.exists()) {
      existing = snap.data()
      return
    }
    tx.set(ref, {
      email: user.email,
      createdAt: serverTimestamp(),
      lastLogin: serverTimestamp(),
      balance: 0,
      plan: "free",
    })
    created = true
  })
  if (created) return true

  if (touchLogin) {
    await updateDoc(ref, { email: user.email, lastLogin: serverTimestamp() }).catch((err) => {
      console.error("lastLogin update failed", err)
    })
  }

  // Repair docs that are missing the defaults (allowed only while the field is absent).
  const missing = {}
  if (!("createdAt" in existing)) {
    const authCreated = Date.parse(user.metadata?.creationTime || "")
    missing.createdAt = Number.isNaN(authCreated) ? serverTimestamp() : Timestamp.fromMillis(authCreated)
  }
  if (!("balance" in existing)) missing.balance = 0
  if (!("plan" in existing)) missing.plan = "free"
  if (Object.keys(missing).length > 0) {
    await updateDoc(ref, missing).catch((err) => {
      console.error("user doc repair failed", err)
    })
  }
  return false
}
